import { useEffect, useRef } from '@frontend/react';
import type { ExtractTaskInitialQuestionWithAnswer } from '@frontend/react-domain';
import { TextareaInput, YStack } from '@frontend/web-react';
import { safeCss } from '@frontend/web-utils';

type TextInitialQuestionProps = {
  initialQuestionWithAnswer: ExtractTaskInitialQuestionWithAnswer<'text'>;
  isLoading: boolean;
  onChange: (answer: string) => void;
};

export const TextInitialQuestion = ({ initialQuestionWithAnswer, isLoading, onChange }: TextInitialQuestionProps) => {
  const textAreaInputRef = useRef<HTMLTextAreaElement>(null);
  const onUpdateFreeResponseAnswer = (text: string) => onChange(text);

  useEffect(() => {
    textAreaInputRef.current?.focus();
  }, [initialQuestionWithAnswer.question]);

  return (
    <YStack
      bg="neutral50"
      className="cursor-pointer"
      disabled={isLoading}
      justifyContent="center"
      onClick={() => textAreaInputRef.current?.focus()}
      p="md"
      radius="lg"
    >
      <TextareaInput
        classNames={{
          input: safeCss('bg-neutral-50 border-none text-p-md p-none'),
        }}
        disabled={isLoading}
        label=""
        maxRows={3}
        minRows={1}
        onChange={onUpdateFreeResponseAnswer}
        placeholder="Type your answer"
        ref={textAreaInputRef}
        value={initialQuestionWithAnswer.answer ?? ''}
      />
    </YStack>
  );
};
